import gql from 'graphql-tag';

export default gql`
    query GetAllCustomers {
        getAllCustomers {
            id
            customerName
            description
            enabled
            isDeleted
            extSystemName
            extSystemIdentifier
            industryClassificationCode
            customerParentId
        }
    }
`;
